<!-- src/pages/saju-service/index.vue -->
<script setup>
useSeoMeta({
  title: '낭만분석',
  robots: 'noindex, nofollow',
});

import {
  getGroupUserlist,
  getDetail,
  updateGroup,
  getFavoriteTotal,
  getRealTotal,
} from '@/api/UserGroup';
import { addContentLogAPI } from '@/api/logServiceApi';
import { fastSearch, fastSearchByMySaju, userGroupDel } from '@/api/Eoway';
import { getMemoList } from '@/api/UserGroup';
import { reverseData } from '@/composables/functions';
import useFunctions from '@/composables/useFunctions';
import {
  isPopSajuGroupChange,
  closeGroupChange,
  openGroupSetting,
  isPopSajuGroupSetting,
  closeGroupSetting,
  openGroupChange,
  openMemoReg,
  isPopSajuGroupAdd,
  currentTab,
  openGroupAdd,
  closeGroupAdd,
  isPopMemoList,
  isPopMemoReg,
  closeMemoList,
  closeMemoReg,
} from '@/composables/useGroup';
import { useAnalysisStore } from '@/store/modules/analysis';
import { usePrimarySajuStore } from '@/store/modules/primarySaju';
import { useMobileSajuLnbStore } from '@/store/modules/mobileSajuLnb';
import { useClientType } from '@/composables/useClientType';
import { useBackLayer } from '@/composables/useAppBack';

// components
import IconDivider from '@/components/svg/IconDivider.vue';
import IconDownFill from '@/components/svg/IconDownFill.vue';
import sajuFilterNew from '@/components/saju-service/sajuFilterNew.vue';
import NmaHomeGroup from '@/components/saju-service/NmaHomeGroup.vue';
import NmaHomeSajuGrid from '@/components/saju-service/NmaHomeSajuGrid.vue';
import NmaHomeSajuList from '@/components/saju-service/NmaHomeSajuList.vue';
import { Pagination } from '@/components/board';

// popup
import PopSajuGroupChange from '@/components/saju-service/PopSajuGroupChange.vue';
import PopSajuGroupSetting from '@/components/saju-service/PopSajuGroupSetting.vue';
import PopAddGroup from '@/components/saju-service/PopAddGroup.vue';
import PopMemo from '@/components/saju-service/PopMemo.vue';
import PopAnalysisInfo from '@/components/saju-service/PopAnalysisInfo.vue';
import PopShareBox from '@/components/saju/PopShareBox.vue';
import PopMansePrint from '@/components/saju/PopMansePrint.vue';

// alert
import AlertComponent from '@/components/common/Alert.vue';
import ConfirmComponent from '@/components/common/Confirm.vue';
import Snackbar from '@/components/common/Snackbar.vue';
import MobileHeader from '@/components/common/MobileHeader.vue';
import IconGroupSetting from '@/components/svg/IconGroupSetting.vue';
import MobileGroupManagement from '@/components/analysis/MobileGroupManagement.vue';
import MobileCreditBar from '@/components/analysis/MobileCreditBar.vue';
import MobileSajuSearch from '@/components/saju-service/MobileSajuSearch.vue';
import IconSearch from '@/components/svg/IconSearch.vue';

definePage({ meta: { layout: 'saju-service', title: '낭만분석' } });

const router = useRouter();
const route = useRoute();
const analysisStore = useAnalysisStore();
const primarySajuStore = usePrimarySajuStore();
const mobileSajuLnbStore = useMobileSajuLnbStore();
const { ...useFun } = useFunctions();

// 클라이언트 타입 분기
const { isApp, isMobileUi } = useClientType();

// 대표사주 ID (스토어 → 캐시 스냅샷 순 fallback)
const primarySajuId = computed(
  () => primarySajuStore.primarySajuId ?? cachedPrimarySajuIdSnapshot.value,
);

// 내 사주 ID (스토어 → 캐시 스냅샷 순 fallback)
const mySajuId = computed(() => primarySajuStore.mySajuId ?? cachedMySajuIdSnapshot.value);

/**
 * 페이지 1에서는 내사주/대표사주가 서버 응답에 포함되지 않더라도 최상단에 노출되도록
 * 스토어에 있는 객체를 listData 앞쪽에 주입한다. 정렬 기준(등록순/이름순/나이순 등)에
 * 상관없이 내사주 → 대표사주 → 나머지 순서가 유지되도록 보장한다.
 */
const displayListData = computed(() => {
  const list = Array.isArray(listData.value) ? [...listData.value] : [];
  if (paramData.value.page !== 1) return list;

  const existing = new Set(list.map((item) => item?.guestUserId).filter(Boolean));
  const toPrepend = [];

  // 스토어의 mySaju/primarySaju는 리스트 shape과 필드가 다를 수 있어
  // 리스트 렌더링에 필요한 기본 필드를 보강해서 주입한다.
  // const normalizeForList = (saju) => ({
  //   memoCount: 0,
  //   isFavorite: false,
  //   analysisInfo: [],
  //   userGroup: null,
  //   ...saju,
  // });

  // const mySajuObj = primarySajuStore.mySaju;
  // if (mySajuObj?.guestUserId && !existing.has(mySajuObj.guestUserId)) {
  //   toPrepend.push(normalizeForList(mySajuObj));
  //   existing.add(mySajuObj.guestUserId);
  // }

  // const primarySajuObj = primarySajuStore.primarySaju;
  // if (primarySajuObj?.guestUserId && !existing.has(primarySajuObj.guestUserId)) {
  //   toPrepend.push(normalizeForList(primarySajuObj));
  //   existing.add(primarySajuObj.guestUserId);
  // }

  return toPrepend.length > 0 ? [...toPrepend, ...list] : list;
});

// 모바일 그룹관리 팝업
const showMobileGroupManagement = ref(false);

// 모바일 검색 팝업
const showMobileSearch = ref(false);

const openMobileSearch = () => {
  showMobileSearch.value = true;
};

const handleSearchSelectItem = (item) => {
  showMobileSearch.value = false;
  // 사주 상세 분석 페이지로 이동
  router.push(`/m/saju-insight/${item.guestUserId}`);
};

/** 목록타입 - 갤러리형: 'grid', 리스트형: 'list' */
let isListType = ref(isMobileUi.value ? 'list' : 'grid');

// 모바일 필터 팝업
const showMobileFilter = ref(false);
const { width: windowWidth } = useWindowSize();
const onFilterIconClick = () => {
  if (isMobileUi.value) {
    showMobileFilter.value = true;
  }
};

/** 모바일 컬럼 수에 따른 페이지 사이즈 (3컬럼: 12개, 2컬럼: 16개, PC: 16개) */
const mobilePageSize = computed(() => {
  if (windowWidth.value > 768) return 16;
  return windowWidth.value >= 600 ? 15 : 16;
});

//리스트 정보 조회
let listData = ref([]);
let totalElements = ref(0);
let totalPages = ref(0);
const totalCount = ref(0);
const favoriteCount = ref(null);
const isLoading = ref(false);
const isInitialLoading = ref(true);

const _cachedUserId = sessionStorage.getItem('authUserId');

// Pinia 캐시가 miss일 때를 대비한 fallback 용도의 ID 스냅샷
const cachedPrimarySajuIdSnapshot = ref(null);
const cachedMySajuIdSnapshot = ref(null);

const LIST_CACHE_KEY = 'saju-service-list-cache';

const saveListCache = (userId) => {
  if (!userId || paramData.value.page !== 1) return;
  try {
    sessionStorage.setItem(
      LIST_CACHE_KEY,
      JSON.stringify({
        userId,
        listData: listData.value,
        totalElements: totalElements.value,
        totalPages: totalPages.value,
        totalCount: totalCount.value,
        favoriteCount: favoriteCount.value,
        primarySajuIdSnapshot: primarySajuStore?.primarySajuId ?? null,
        mySajuIdSnapshot: primarySajuStore?.mySajuId ?? null,
      }),
    );
  } catch (e) {
    console.warn('Failed to save saju list cache', e);
  }
};

const restoreListCache = (userId) => {
  if (!userId) return false;
  try {
    const raw = sessionStorage.getItem(LIST_CACHE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    if (parsed.userId !== userId) return false;
    listData.value = parsed.listData ?? [];
    totalElements.value = parsed.totalElements ?? 0;
    totalPages.value = parsed.totalPages ?? 0;
    if (parsed.totalCount != null) totalCount.value = parsed.totalCount;
    if (parsed.favoriteCount != null) favoriteCount.value = parsed.favoriteCount;
    cachedPrimarySajuIdSnapshot.value = parsed.primarySajuIdSnapshot ?? null;
    cachedMySajuIdSnapshot.value = parsed.mySajuIdSnapshot ?? null;
    return true;
  } catch (e) {
    console.warn('Failed to restore saju list cache', e);
    return false;
  }
};

// setup 단계에서 캐시를 동기 복원해 첫 렌더 시 스피너 없이 이전 목록을 즉시 표시
if (_cachedUserId && restoreListCache(_cachedUserId)) {
  isInitialLoading.value = false;
}

const langMode = ref('CHNKOR');

//검색조건
let paramData = ref({
  birthStart: null,
  birthEnd: null,
  startDate: null,
  endDate: null,
  genderOption: 0,
  page: 1,
  size: 16,
  searchKeyWord: '',
  sortOption: null,
  userGroupId: null,
  activeOpt1: false,
  activeOpt2: false,
  activeOpt3: false,
  activeOpt4: false,
  fiveEles: [],
  gender: null,
  filterFlag: false,
  isFavorite: null,
});

const resetAll = () => {
  paramData.value.birthStart = null;
  paramData.value.birthEnd = null;
  paramData.value.startDate = null;
  paramData.value.searchKeyWord = '';
  paramData.value.activeOpt1 = false;
  paramData.value.activeOpt2 = false;
  paramData.value.activeOpt3 = false;
  paramData.value.activeOpt4 = false;
  paramData.value.fiveEles = [];
  paramData.value.gender = [];
  paramData.value.page = 1;

  fetchListOne(isListType.value);
  if (refUserFilter.value) {
    refUserFilter.value.fetchFilterReset();
  } else {
    console.error('refUserFilter가 정의되지 않았습니다.');
  }
};

const requestFetchList = () => {
  paramData.value.searchKeyWord = '';
  fetchListOne(isListType.value);
};

const setParamData = (noOrNewParamData) => {
  if (typeof noOrNewParamData === 'object') {
    paramData.value = { ...paramData.value, ...noOrNewParamData };
  } else {
    paramData.value[`activeOpt${noOrNewParamData}`] =
      !paramData.value[`activeOpt${noOrNewParamData}`];
  }
};
const setFilterData = (options) => {
  paramData.value = { ...paramData.value, ...options.value };
  if (paramData.value.gender === null || paramData.value.gender === '') {
    delete paramData.value.gender;
  }
  if (paramData.value.fiveEles === null || paramData.value.fiveEles === '') {
    delete paramData.value.fiveEles;
  }

  paramData.value.page = 1;
  fetchListOne(isListType.value);
};

const tabSearch = (userGroupId) => {
  if (userGroupId > 0) {
    paramData.value.userGroupId = userGroupId;
  } else {
    delete paramData.value.userGroupId;
  }
  paramData.value.page = 1;
  fetchListOne(isListType.value);
};

/** 즐겨찾기 상태 관리 */
const isSelectFavorite = (isFavorite) => {
  // true 또는 null 만 사용
  paramData.value.isFavorite = isFavorite;
};

const showFavorite = () => {
  paramData.value = {
    ...paramData.value,
    userGroupId: null,
    isFavorite: true,
  };
  fetchListOne(isListType.value);
};

const fetchList = async (typ, option = '') => {
  try {
    isLoading.value = true;
    isListType.value = typ;
    const params = reactive({ ...paramData.value, size: mobilePageSize.value });
    const data = await getGroupUserlist(params); // 저장목록 조회
    totalElements.value = data.totalElements;
    totalPages.value = data.totalPages;
    listData.value = [...data.content];
    saveListCache(paramData.value.userId);
    getTotalCount();
    refUserGroup.value.fetchGroup();
    primarySajuStore.fetchPrimarySaju(); // 대표사주 새로고침
    primarySajuStore.fetchMySaju(); // 내 사주 새로고침
  } catch (error) {
    console.error('Failed to load users:', error);
  } finally {
    isLoading.value = false;
  }
};

const fetchListOne = async (typ) => {
  try {
    isLoading.value = true;
    isListType.value = typ;
    const params = reactive({ ...paramData.value, size: mobilePageSize.value });
    const data = await getGroupUserlist(params); // 저장목록 조회
    totalElements.value = data.totalElements;
    totalPages.value = data.totalPages;
    listData.value = data.content;
    saveListCache(paramData.value.userId);
    getTotalCount();
    refUserGroup.value.fetchGroup();
    primarySajuStore.fetchPrimarySaju(); // 대표사주 새로고침
    primarySajuStore.fetchMySaju(); // 내 사주 새로고침
  } catch (error) {
    console.error('Failed to load users:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  window.addEventListener('click', handleClickOutside);

  // 모바일 저장목록 진입 로그 — 기존 type 재사용 (회원상세 활동 정리 v0.2)
  if (isMobileUi.value) addContentLogAPI('saju_list_navigation_go_saju_result');

  const userId = sessionStorage.getItem('authUserId');
  if (!userId) return;
  paramData.value.userId = userId;

  // 안내 팝업은 API 대기 없이 먼저 노출 (모바일/쿼리 진입 제외)
  const prSelectedGroupQuery = router.currentRoute.value.query?.prSelectedGroup;
  if (!prSelectedGroupQuery) {
    showAnalysisPopup();
  }

  // 대표사주 및 내 사주 조회
  await Promise.all([primarySajuStore.fetchPrimarySaju(), primarySajuStore.fetchMySaju()]);

  try {
    await fetchList(isListType.value);
  } finally {
    isInitialLoading.value = false;
  }

  const message = localStorage.getItem('showSnackbarAfterRefresh');
  if (message) {
    triggerSnackbar(message);
    localStorage.removeItem('showSnackbarAfterRefresh');
  }
  if (prSelectedGroupQuery) {
    tabSearch(prSelectedGroupQuery);
  }
});

onUnmounted(() => {
  window.removeEventListener('click', handleClickOutside);
});

/** 페이지 변경 */
const changePage = async (page) => {
  paramData.value.page = page;
  await fetchListOne(isListType.value);
};

const selectedGroup = ref({});
const selectedListItem = ref({});
const userGroupId = ref(null);
const userGroupName = ref('미지정');
const refUserGroup = ref(null);
const refUserFilter = ref(null);
const refUserFilterWrap = ref(null);
const refMobileFilter = ref(null);

const handleMobileFilterReset = () => {
  resetAll();
  if (refMobileFilter.value) {
    refMobileFilter.value.fetchFilterReset();
  }
};

function handleGroupChange(selectedGroupItem) {
  openGroupChange();
  selectedGroup.value = selectedGroupItem;
  selectedListItem.value = selectedGroupItem;
}

//그룹선택저장
async function changeGroup(selectedChangeGroup) {
  userGroupId.value = selectedChangeGroup[0]?.userGroupId;
  userGroupName.value = selectedChangeGroup[0]?.name;
  try {
    await updateGroup({
      guestUserId: selectedGroup.value.guestUserId,
      userGroupId: userGroupId.value,
    });
    const user = listData.value.find(
      (item) => item.guestUserId === selectedGroup.value.guestUserId,
    );
    if (user) {
      user.userGroup.name = userGroupName.value;
      user.userGroup.userGroupId = userGroupId.value;
    }
  } catch (error) {
    showDialogAlert(error.message || 'Error occurred while fetching details.'); // 에러 메시지 표시
  }
  isPopSajuGroupChange.value = false;
  groupListDataRefresh();
  triggerSnackbar('그룹이 선택되었습니다.');
}

//정렬변경
const onSortOptionChange = (value) => {
  paramData.value.sort = value.abbr;
  paramData.value.page = 1;
  fetchListOne(isListType.value);
};
const isMobileSortMenuOpen = ref(false);
const isMobileSort = computed(() => isMobileUi.value);

const selectedSortOption = ref({
  state: '등록순',
  abbr: 'createdAt.desc',
});

const sortOptionItems = [
  {
    state: '등록순',
    abbr: 'createdAt.desc',
  },
  {
    state: '이름순',
    abbr: 'guestUserName.asc',
  },
  {
    state: '나이순',
    abbr: 'age.desc',
  },
  {
    state: '목화토금수 순',
    abbr: 'fiveEle.asc',
  },
];

const selectSortOption = (option) => {
  selectedSortOption.value = option;
  onSortOptionChange(option);
  isMobileSortMenuOpen.value = false;
};

function groupListDataRefresh(type) {
  if (refUserGroup.value) {
    refUserGroup.value.fetchGroup();
  }
  //본문 목록 재호출
  fetchListOne(isListType.value);
  // 스낵바 띄우기
  let message = '';
  if (type === 'add') {
    message = '그룹 추가가 완료되었습니다';
  } else if (type === 'update') {
    message = '그룹명이 수정되었습니다';
  } else if (type === 'order') {
    message = '그룹 순서가 변경되었습니다.';
  }

  if (message) {
    triggerSnackbar(message);
  }
}

const memoData = ref([]);
const memoListData = ref({});
const listGroupMemoRefresh = async (memoTxt = '', selectedGuestUserId) => {
  try {
    const params = {};
    if (memoTxt !== '') params.content = memoTxt;
    params.guestUserId =
      selectedMemoListItem.value?.guestUserId ||
      selectedMemoListItemVal.value?.guestUserId ||
      selectedGuestUserId;
    params.sort = 'createdAt.desc';
    params.size = 30;
    const data = await getMemoList(params); // 그룹리스트 조회
    memoData.value = data.content;

    // listData 초기화
    Object.keys(memoListData.value).forEach((key) => {
      delete memoListData.value[key];
    });

    // 데이터 그룹화
    memoData.value.forEach((data) => {
      const createdAt = new Date(data.createdAt);
      const monthYear = `${createdAt.getFullYear()}.${`0${createdAt.getMonth() + 1}`.slice(-2)}`;

      if (!memoListData.value[monthYear]) {
        memoListData.value[monthYear] = [];
      }

      memoListData.value[monthYear].push(data);
    });
    //본문 목록 재호출
    fetchListOne(isListType.value);
  } catch (error) {
    console.error('Failed to load users:', error);
  }
};

const listGroupMemoDel = async () => {
  showDialogAlert('삭제되었습니다.', '');
  await listGroupMemoRefresh();
  fetchListOne(isListType.value);
};
const selectedMemoListItem = ref({});
const selectedMemoListItemVal = ref(null);
const memoModeType = ref(null);

//메모 열기
function handleOpenMemoReg(selectedItem, typ) {
  selectedMemoListItem.value = selectedItem;
  memoModeType.value = typ;
  openMemoReg();
}

function handleOpenMemoList(selectedItem, typ) {
  selectedMemoListItem.value = selectedItem;
  memoModeType.value = typ;
  openMemoList();
}

function openMemoListReg(selectedItem) {
  selectedMemoListItem.value = selectedItem;
  selectedMemoListItemVal.value = null;
  memoModeType.value = 'list';
  openMemoReg();
}

function openMemoListView(selectedMemo, selectedItem) {
  selectedMemoListItemVal.value = selectedItem;
  selectedMemoListItem.value = selectedMemo;
  memoModeType.value = 'edit';
  openMemoReg();
}

const formData = ref({});

const rsData = ref({});

const getEowaySearch = async (id, isPrint) => {
  let rsFlag = false;
  const result = await getDetail(id);

  formData.value.userName = result.guestUserName;
  formData.value.gender = result.gender === 'MEN' ? 1 : 0;
  formData.value.isLunar = result.isLuna;
  formData.value.isLeapYear = result.isLeapYear;
  formData.value.addressTxt = result.bornArea;
  formData.value.bornAreaId = result.bornAreaId;
  formData.value.option1 = result.option1;
  formData.value.option2 = result.option2;
  formData.value.option3 = result.option3;
  formData.value.option4 = result.option4;
  formData.value.option5 = result.option5;
  formData.value.birth = result.birth;
  formData.value.birthTime = result.birthTime;
  if (isPrint) {
    formData.value.lang = 'KOR';
    sessionStorage.setItem('langMode', langMode.value);
  } else {
    formData.value.lang = 'KOR';
  }
  const isMine =
    result.isMySaju === true || primarySajuStore.isMySaju(Number(id));
  const rsDataAll = isMine
    ? await fastSearchByMySaju(Number(id), formData.value.userName, formData.value.lang || 'KOR')
    : await fastSearch(formData.value);
  if (Object.keys(rsDataAll)?.length > 0) {
    if (!isPrint) {
      rsData.value = {
        ...rsDataAll,
        daeuns: {
          sky: reverseData(rsDataAll.daeuns.sky),
          earth: reverseData(rsDataAll.daeuns.earth),
        },
        years: {
          sky: reverseData(rsDataAll.years.sky),
          earth: reverseData(rsDataAll.years.earth),
        },
        months: {
          sky: reverseData(rsDataAll.months.sky),
          earth: reverseData(rsDataAll.months.earth),
        },
      };
    } else {
      rsData.value = rsDataAll;
    }
    const reversedRsDataAll = {
      ...rsDataAll, // 기존 데이터 복사
      daeuns: {
        ...rsDataAll.daeuns, // daeuns 객체 복사
        sky: reverseData(rsDataAll.daeuns.sky), // sky 역순
        earth: reverseData(rsDataAll.daeuns.earth), // earth 역순
      },
    };
    sessionStorage.setItem('printData', JSON.stringify(reversedRsDataAll));
    sessionStorage.setItem('printformData', JSON.stringify(formData.value));
    rsFlag = true;
  }
  return rsFlag;
};

/** 상세분석 클릭 */
const clickAnalysisButton = (sajuItem) => {
  const { guestUserId, guestUserName, birth, birthTime } = sajuItem || {};

  const birthYear = Number(birth.split('-')[0]);
  const currentYear = new Date().getFullYear();

  const isFutureSaju = birthYear > currentYear;
  const isUnknownTime = birthTime === '25:00';

  if (isFutureSaju) {
    showFutureSajuConfirm();
    return;
  }

  if (isUnknownTime) {
    showUnknownTimeConfirm();
    return;
  }

  const requestedMenu = ['/overviewNangmanHarmony', '/overviewNangmanNaming'].includes(route.query.menu)
    ? route.query.menu
    : '/overviewSajuSummary';
  analysisStore.selectedMenu = requestedMenu;
  if (guestUserName) analysisStore.setUserName(guestUserName);
  if (guestUserId) router.push({ path: `/analysis/${guestUserId}`, query: { menu: requestedMenu } });
};

// 검색어 Chip (그냥 paramData로 보내면 실시간 연동됨)
const searchFilterKeyWord = ref('');
const handleSearch = () => {
  fetchListOne(isListType.value);
  if (paramData.value.searchKeyWord) {
    searchFilterKeyWord.value = paramData.value.searchKeyWord;
    console.log('searchFilterKeyWord:', searchFilterKeyWord.value);
  }
};

/** 즐겨찾기 토글 버튼 */
const toggleFavoriteHandler = async (guestUserId, isFavorite) => {
  try {
    const user = listData.value.find((item) => item.guestUserId === guestUserId);
    if (user) {
      user.isFavorite = isFavorite;
      await updateGroup({ guestUserId, isFavorite });
      await favoriteTotal();
    }
  } catch (error) {
    console.error('즐겨찾기 상태 업데이트 중 오류:', error);
  }
};

/** 대표사주 설정 */
const setPrimaryHandler = async (guestUserId, birthTime) => {
  if (birthTime === '25:00') {
    showDialogAlert('시간 모름인 사주는\n낭만브리핑으로 지정할 수 없습니다.');
    return;
  }
  showDialogConfirm(
    '이 사주를 낭만브리핑으로 지정할까요?',
    '홈에서 제공되는 오늘의 운세, 주간 흐름 등\n무료 개인화 사주 해석이\n이 사주 기준으로 보여집니다.\n\n기존 브리핑 사주는 자동으로 변경됩니다.',
    '브리핑 지정',
    async () => {
      await nextTick();
      try {
        const success = await primarySajuStore.setPrimarySaju(guestUserId);
        if (success) {
          snackbar.value.showSnackbar('낭만브리핑 사주로 지정되었습니다.');
          // 설정된 대표사주를 바로 확인할 수 있도록 1페이지로 이동
          paramData.value.page = 1;
          await fetchList(isListType.value);
        } else {
          snackbar.value.showSnackbar('낭만브리핑 설정 중 오류가 발생했습니다.');
        }
      } catch (error) {
        console.error('낭만브리핑 설정 중 오류:', error);
        snackbar.value.showSnackbar('낭만브리핑 설정 중 오류가 발생했습니다.');
      }
    },
    '',
    'confirm-title-text',
  );
};

/** 이미 대표사주로 지정된 경우 알림 */
const showAlreadyPrimaryHandler = () => {
  showDialogAlert('이미 낭만브리핑으로 지정된 사주입니다.');
};

/** 즐겨찾기 ↔ 필터 독립 */
const deactivateFavor = ref(false);

/** 목록 타입 유지 함수 */
// 피드백에 따라 수정
const setListType = (type) => {
  isListType.value = type;
  localStorage.setItem('listType', type);
  addContentLogAPI({
    contentType: 'saju_list_btn_view_mode_opt3',
    option3: type,
  });
};

/** 즐겨찾기/전체 그룹의 사주 totalCount 가져오기 */
const getTotalCount = () => {
  getSajuTotal();
  favoriteTotal();
};

/** 즐겨찾기 총개수 */
const favoriteTotal = async () => {
  try {
    const data = await getFavoriteTotal();
    favoriteCount.value = data.FavoriteCount;
    saveListCache(paramData.value.userId);
  } catch (error) {
    console.error('즐겨찾기 총 개수 받아오기 실패:', error);
  }
};

/** '전체'그룹 개수 받아오기 */
const getSajuTotal = async () => {
  try {
    const result = await getRealTotal();
    totalCount.value = result.totalCount;
    saveListCache(paramData.value.userId);
  } catch (e) {
    console.error('전체 개수 받아오기 실패:', e);
  }
};

/** 필터 외부 영역 클릭 감지 */
// 필터 외부 영역 클릭시 필터 닫힘
const handleClickOutside = (event) => {
  if (refUserFilterWrap.value && !refUserFilterWrap.value.contains(event.target)) {
    if (paramData.value.activeOpt1) {
      setParamData(1);
    }
    if (paramData.value.activeOpt2) {
      setParamData(2);
    }
    if (paramData.value.activeOpt3) {
      setParamData(3);
    }
    if (paramData.value.activeOpt4) {
      setParamData(4);
    }
  }
};

// ==============================
// 공유하기, 출력하기
// ==============================
const shareData = ref(null);
const isPrint = ref(false);
const isPopShareBox = ref(false);
const isPopMansePrint = ref(false);

const shareResultTextByNative = async () => {
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') return false;

  const sharePayload = {
    title: '낭만만세력 사주결과',
    text: useFun.convertShareTxt(rsData.value),
  };

  if (typeof navigator.canShare === 'function' && !navigator.canShare(sharePayload)) {
    return false;
  }

  await navigator.share(sharePayload);
  return true;
};

const isShareCanceledError = (error) => {
  const errorName = error?.name || '';
  const errorMessage = error?.message || '';
  return (
    errorName === 'AbortError' ||
    /abort|cancel|dismiss/i.test(errorName) ||
    /abort|cancel|dismiss/i.test(errorMessage)
  );
};

const shareOpen = async (id) => {
  isPrint.value = false;
  const result = await getEowaySearch(id, isPrint.value);
  if (result) {
    if (isMobileUi.value) {
      try {
        const isShared = await shareResultTextByNative();
        if (isShared) return;
      } catch (error) {
        if (isShareCanceledError(error)) return;
        console.error('기기 기본 공유 실패:', error);
      }
    }

    isPopShareBox.value = true;
  }
};

const share = () => {
  shareData.value = useFun.convertShareTxt(rsData.value);
};

const closePopShareBox = () => {
  isPopShareBox.value = false;
};

const printManse = async (id) => {
  isPrint.value = true;
  const rsFalg = await getEowaySearch(id, isPrint.value);
  if (rsFalg) {
    isPopMansePrint.value = true;
  }
};

const closePopMansePrint = () => {
  isPopMansePrint.value = false;
};

// ==============================
// 낭만분석 안내 팝업
// ==============================
const isAnalysisPopupVisible = ref(false);

const showAnalysisPopup = () => {
  // 차단 여부는 PopAnalysisInfo 내부에서 판단 (nmp_popup_analysis_guide_hide_until)
  isAnalysisPopupVisible.value = true;
};

const closeAnalysisPopup = () => {
  isAnalysisPopupVisible.value = false;
};

// ==============================
// alert, confirm, snackbar
// ==============================
const dialogAlert = ref(null);
const dialogConfirm = ref(null);
const snackbar = ref(null);

const dialogTitle = ref('');
const dialogTitleClass = ref('');
const dialogTitle2 = ref('');
const dialogText = ref('');
const dialogNextUrl = ref('');
const warningTxt = ref('');

const showDialogAlert = (title, text = '', nextUrl = '', warning = '') => {
  dialogTitle.value = title;
  dialogText.value = text;
  dialogNextUrl.value = nextUrl;
  warningTxt.value = warning;
  dialogAlert.value.openAlertDialog();
};

const showAnalysisAlert = ({ title }) => {
  dialogTitle.value = title;
  dialogText.value = '';
  dialogAlert.value.openAlertDialog();
};

const showUnknownTimeConfirm = () => {
  showAnalysisAlert({
    title: `시간 모름인 사주는\n상세분석 서비스 제공이 어렵습니다.`,
  });
};

const showFutureSajuConfirm = () => {
  showAnalysisAlert({
    title: `내년 이후 사주는\n상세분석 서비스 제공이 어렵습니다.`,
  });
};

/** confirm 다이얼로그 보여주기 */
const showDialogConfirm = (
  title,
  title2 = '',
  text = '',
  onConfirm = () => {},
  warning,
  titleClass = '',
) => {
  dialogTitle.value = title;
  dialogTitleClass.value = titleClass;
  dialogTitle2.value = title2;
  dialogText.value = text;
  dialogNextUrl.value = onConfirm; // 함수로 전달
  warningTxt.value = warning;
  dialogConfirm.value.openConfirmDialog();
};

/** 사주저장내용 삭제 */
const delSavedSaju = async (param) => {
  const targetId = Number(param?.guestUsersIds);
  const isMy = !!mySajuId.value && targetId === Number(mySajuId.value);
  const isPrimary = !!primarySajuId.value && targetId === Number(primarySajuId.value);

  let title = '사주를 삭제하시겠습니까?';
  let text = '삭제된 정보는 다시 볼 수 없습니다.';
  if (isMy && isPrimary) {
    title = '내 사주이자 홈 낭만브리핑 사주를 삭제하시겠습니까?';
    text =
      '삭제 후 부가정보에서 내 사주를 다시 등록할 수 있어요.\n메인 페이지 낭만브리핑이 비워지고, 다른 사주를 지정해야 표시돼요.';
  } else if (isMy) {
    title = '내 사주를 삭제하시겠습니까?';
    text = '삭제 후 부가정보에서 다시 등록할 수 있어요.';
  } else if (isPrimary) {
    title = '홈 낭만브리핑 사주를 삭제하시겠습니까?';
    text = '삭제하면 메인 페이지 낭만브리핑이 비워지고, 다른 사주를 지정해야 표시돼요.';
  }

  showDialogConfirm(
    title,
    text,
    '삭제',
    async () => {
      await nextTick();
      confirmDeleteSaju(param);
    },
    '※  일진 서비스 결제 · 이용내역도 함께 삭제되며 \n복구되지 않으니 주의하세요.',
    'confirm-highlight-orange',
  );
};

const confirmDeleteSaju = async (param) => {
  showDialogConfirm(
    '정말 삭제하시겠습니까?',
    '영구적으로 사주 정보가 삭제되고, \n 이용내역은 복구가 불가능합니다.',
    '삭제',
    async () => {
      await userGroupDel(param);
      localStorage.setItem('showSnackbarAfterRefresh', '사주정보가 삭제되었습니다');
      await fetchList(isListType.value);
    },
    undefined,
    'confirm-highlight-orange',
  );
};

/** 스낵바 띄우기 */
function triggerSnackbar(message) {
  snackbar.value.showSnackbar(message);
}

useBackLayer({
  id: 'saju-service-entry-guide',
  isOpen: isAnalysisPopupVisible,
  closeFromBack: closeAnalysisPopup,
});
useBackLayer({
  id: 'saju-service-mobile-group-management',
  isOpen: showMobileGroupManagement,
  closeFromBack: () => {
    showMobileGroupManagement.value = false;
  },
});
useBackLayer({
  id: 'saju-service-mobile-search',
  isOpen: showMobileSearch,
  closeFromBack: () => {
    showMobileSearch.value = false;
  },
});
useBackLayer({
  id: 'saju-service-mobile-filter',
  isOpen: showMobileFilter,
  closeFromBack: () => {
    showMobileFilter.value = false;
  },
});
useBackLayer({
  id: 'saju-service-mobile-sort',
  isOpen: isMobileSortMenuOpen,
  closeFromBack: () => {
    isMobileSortMenuOpen.value = false;
  },
});
useBackLayer({
  id: 'saju-service-group-change',
  isOpen: isPopSajuGroupChange,
  closeFromBack: closeGroupChange,
});
useBackLayer({
  id: 'saju-service-group-add',
  isOpen: isPopSajuGroupAdd,
  closeFromBack: closeGroupAdd,
});
useBackLayer({
  id: 'saju-service-group-setting',
  isOpen: isPopSajuGroupSetting,
  closeFromBack: closeGroupSetting,
});
useBackLayer({
  id: 'saju-service-memo-list',
  isOpen: isPopMemoList,
  closeFromBack: closeMemoList,
});
useBackLayer({
  id: 'saju-service-memo-edit',
  isOpen: isPopMemoReg,
  closeFromBack: closeMemoReg,
});
useBackLayer({
  id: 'saju-service-print',
  isOpen: isPopMansePrint,
  closeFromBack: closePopMansePrint,
});
useBackLayer({
  id: 'saju-service-share',
  isOpen: isPopShareBox,
  closeFromBack: closePopShareBox,
});
</script>

<template>
  <div class="content-main mb-large">
    <MobileHeader title="저장목록" :show-back="false" :show-menu="!isMobileUi">
      <template v-if="isMobileUi" #right-prepend>
        <button class="mobile-header__tool-btn" @click="showMobileGroupManagement = true">
          <IconGroupSetting />
        </button>
        <button class="mobile-header__tool-btn" @click="openMobileSearch">
          <IconSearch />
        </button>
      </template>
    </MobileHeader>
    <section class="inner-base st-wd-100per">
      <div class="top_header_text_title" v-if="!isMobileUi">
        <div class="tit-box">
          <p class="title">저장목록</p>
          <button
            @click="openGroupSetting()"
            class="btn-group-setting top_header_button_group_setting"
          >
            <i class="icon-setting" />그룹관리
          </button>
          <button class="mobile-title-group-setting-btn" @click="showMobileGroupManagement = true">
            <IconGroupSetting />
          </button>
          <button class="mobile-title-search-btn" @click="openMobileSearch">
            <IconSearch />
          </button>
        </div>
        <div class="row-box">
          <div class="exp">저장된 사주 정보의 그룹을 설정하여 편리하게 관리하실 수 있습니다.</div>
          <div class="search-box">
            <VTextField
              type="text"
              class="input top_search_input"
              variant="underlined"
              density="compact"
              clearable
              v-model="paramData.searchKeyWord"
              placeholder="이름, 생년월일(920101), 한글사주로 검색 가능합니다."
              @keyup.enter="handleSearch"
              @focus="wordFocus = true"
              @blur="wordFocus = false"
            >
              <template #append-inner>
                <VBtn variant="text" class="btn top_search_image_icon" @click="handleSearch">
                  <i class="icon-search" />
                </VBtn>
              </template>
            </VTextField>
          </div>
        </div>
      </div>

      <NmaHomeGroup
        ref="refUserGroup"
        :pr-group-list-data="groupListData"
        :totalElements="totalCount"
        :favorite-total="favoriteCount"
        :deactivateFavor="deactivateFavor"
        @requestFavoriteTotal="favoriteTotal"
        @popGroupSetting="() => {}"
        @tabSearch="tabSearch"
        @openMobileGroupManagement="showMobileGroupManagement = true"
        fetchGroup
        @showFavorite="showFavorite"
        @isSelectFavorite="isSelectFavorite"
      />

      <div class="result-box">
        <div class="data-box">
          <div class="hd-box">
            <div class="count">
              <div class="result-num toolbar_filter_text_count">
                <i class="icon-filter" @click="onFilterIconClick">아이콘</i>
                <span v-if="!isInitialLoading" class="no">{{ totalElements }}건</span>
              </div>
              <div class="filter-box">
                <div ref="refUserFilterWrap" class="new-filter">
                  <sajuFilterNew
                    ref="refUserFilter"
                    :paramData="paramData"
                    :searchFilterKeyWord="searchFilterKeyWord"
                    @update:paramData="setParamData"
                    @update:searchFilterKeyWord="searchFilterKeyWord = $event"
                    @requestFetchList="requestFetchList"
                    @change:filterData="setFilterData"
                    @resetAll="resetAll"
                  />
                </div>
              </div>
              <div v-if="isSearchWord" class="search-list">
                {{ paramData.searchKeyWord }}
                <button class="close-button sm" @click="delSearchWord()">삭제</button>
              </div>
            </div>

            <!-- 모바일 필터 팝업 -->
            <Teleport to="body">
              <div
                v-show="showMobileFilter"
                class="mobile-filter-overlay"
                @click.self="showMobileFilter = false"
              >
                <div class="mobile-filter-popup">
                  <div class="mobile-filter-header">
                    <span class="mobile-filter-title">사주정보 필터</span>
                    <button class="mobile-filter-close" @click="showMobileFilter = false">
                      <VIcon icon="ri-close-line" size="22" />
                    </button>
                  </div>
                  <div class="mobile-filter-body">
                    <sajuFilterNew
                      ref="refMobileFilter"
                      :paramData="paramData"
                      :searchFilterKeyWord="searchFilterKeyWord"
                      :isMobilePopup="true"
                      @update:paramData="setParamData"
                      @update:searchFilterKeyWord="searchFilterKeyWord = $event"
                      @requestFetchList="requestFetchList"
                      @change:filterData="setFilterData"
                      @resetAll="resetAll"
                    />
                  </div>
                  <div class="mobile-filter-footer">
                    <button class="btn-reselect" @click="handleMobileFilterReset">재선택</button>
                    <button class="btn-confirm" @click="showMobileFilter = false">확인</button>
                  </div>
                </div>
              </div>
            </Teleport>
            <div class="btn-r">
              <VMenu
                v-if="isMobileSort"
                v-model="isMobileSortMenuOpen"
                location="bottom end"
                offset="6"
                content-class="saju-popup-menu"
              >
                <template #activator="{ props }">
                  <button type="button" class="mobile-sort-trigger" v-bind="props">
                    <span class="mobile-sort-text">{{ selectedSortOption.state }}</span>
                    <IconDownFill :isUp="isMobileSortMenuOpen" />
                  </button>
                </template>

                <VList class="mobile-sort-menu">
                  <VListItem
                    v-for="option in sortOptionItems"
                    :key="option.abbr"
                    :class="{ 'is-active': selectedSortOption?.abbr === option.abbr }"
                    @click="selectSortOption(option)"
                  >
                    <VListItemTitle>{{ option.state }}</VListItemTitle>
                  </VListItem>
                </VList>
              </VMenu>
              <VSelect
                v-else
                v-model="selectedSortOption"
                :items="sortOptionItems"
                item-title="state"
                item-value="abbr"
                class="h-middle toolbar_sort_button"
                label="정렬"
                persistent-hint
                return-object
                single-line
                placeholder="정렬"
                @update:modelValue="onSortOptionChange"
              >
                <template #appendInner>
                  <IconDownFill :isUp="false" />
                </template>
              </VSelect>
              <div class="view-style-btn">
                <button
                  class="btn-grid toolbar_view_mode_image_grid"
                  :class="{ active: isListType === 'grid' }"
                  @click="setListType('grid')"
                >
                  갤러리
                </button>
                <IconDivider class="divider" />
                <button
                  class="btn-list toolbar_view_mode_image_list"
                  :class="{ active: isListType === 'list' }"
                  @click="setListType('list')"
                >
                  리스트
                </button>
              </div>
            </div>
          </div>

          <div v-if="isInitialLoading" class="saju-list-loading">
            <v-progress-circular :size="50" :width="3" color="primary" indeterminate />
          </div>
          <div v-else-if="isListType === 'grid'">
            <NmaHomeSajuGrid
              :pr-list-data="displayListData"
              :pr-selected-group="paramData?.userGroupId"
              :primary-saju-id="primarySajuId"
              :my-saju-id="mySajuId"
              @printclick="printManse"
              @shareclick="shareOpen"
              @openChange="handleGroupChange"
              @openMemoReg="handleOpenMemoReg"
              @openMemoList="handleOpenMemoList"
              @showAnalysis="showAnalysisPopup"
              @toggleFavorite="toggleFavoriteHandler"
              @showAnalysisAlert="clickAnalysisButton"
              @delSaju="delSavedSaju"
              @setPrimary="setPrimaryHandler"
            />
          </div>
          <div v-else-if="isListType === 'list'">
            <NmaHomeSajuList
              :pr-list-data="displayListData"
              :pr-selected-group="paramData?.userGroupId"
              :primary-saju-id="primarySajuId"
              :my-saju-id="mySajuId"
              @openChange="handleGroupChange"
              @openMemoReg="handleOpenMemoReg"
              @openMemoList="handleOpenMemoList"
              @printclick="printManse"
              @shareclick="shareOpen"
              @showAnalysis="showAnalysisPopup"
              @toggleFavorite="toggleFavoriteHandler"
              @showAnalysisAlert="clickAnalysisButton"
              @delSaju="delSavedSaju"
              @setPrimary="setPrimaryHandler"
              @showAlreadyPrimary="showAlreadyPrimaryHandler"
            />
          </div>

          <Pagination
            v-if="totalElements > 0"
            :total-pages="totalPages"
            :current-page="paramData.page"
            :max-visible-pages="isMobileUi ? 5 : 10"
            @page-changed="changePage"
          />
        </div>
      </div>
    </section>

    <!-- 모바일 하단 분석권/포인트 바 -->
    <MobileCreditBar class="saju-service-mobile-credit-bar" />
  </div>

  <!-- 그룹 선택 팝업 -->
  <PopSajuGroupChange
    v-if="isPopSajuGroupChange"
    :pr-selected-group="selectedGroup"
    @click="closeGroupChange"
    @change="changeGroup"
    @openSetting="openGroupSetting"
  />

  <!-- 그룹 추가 팝업 -->
  <PopAddGroup
    v-if="isPopSajuGroupAdd"
    :currentTab="currentTab"
    @close="closeGroupAdd"
    @change="changeGroup"
    @refresh="groupListDataRefresh"
    @openSetting="openGroupSetting"
  />

  <!-- 그룹관리 팝업 (PC) - MobileGroupManagement로 통합 -->
  <Teleport to="body">
    <MobileGroupManagement
      v-if="isPopSajuGroupSetting"
      mode="pc"
      @close="closeGroupSetting"
      @refresh="groupListDataRefresh"
    />
  </Teleport>
  <!-- 기존 PC 그룹관리 팝업 (MobileGroupManagement로 교체됨, 일단 보존)
  <PopSajuGroupSetting
    v-if="isPopSajuGroupSetting"
    @change="changeGroup"
    @openSetting="openGroupSetting"
    @close="closeGroupSetting"
    @refresh="groupListDataRefresh"
  />
  -->

  <!-- 메모 팝업 -->
  <PopMemo
    v-if="isPopMemoList || isPopMemoReg"
    :pr-selected-memo="selectedMemoListItem"
    :pr-selected-memo-val="selectedMemoListItemVal"
    :pr-memo-mode-type="memoModeType"
    :pr-memo-list-data="memoListData"
    @getMemoList="listGroupMemoRefresh"
    @openMemoView="openMemoListView"
    @openMemoReg="openMemoListReg"
    @listGroupMemoDel="listGroupMemoDel"
    @listGroupMemo="listGroupMemoRefresh"
  />

  <!-- 출력하기 화면 -->
  <PopMansePrint v-if="isPopMansePrint" @close="closePopMansePrint()" />

  <!-- 공유하기 -->
  <PopShareBox v-if="isPopShareBox" :pr-data="rsData" @close="closePopShareBox()" @share="share" />

  <!-- 낭만분석 안내 팝업 -->
  <PopAnalysisInfo
    :is-visible="isAnalysisPopupVisible"
    @close="closeAnalysisPopup"
    @confirm="closeAnalysisPopup"
  />

  <AlertComponent
    ref="dialogAlert"
    :title="dialogTitle"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
  />

  <ConfirmComponent
    ref="dialogConfirm"
    :title="dialogTitle"
    :titleClass="dialogTitleClass"
    :title2="dialogTitle2"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
    :warning="warningTxt"
  />

  <Snackbar ref="snackbar" />

  <!-- 모바일 그룹관리 팝업 -->
  <Teleport to="body">
    <MobileGroupManagement
      v-if="showMobileGroupManagement"
      @close="showMobileGroupManagement = false"
      @refresh="groupListDataRefresh"
    />
  </Teleport>

  <!-- 모바일 검색 팝업 -->
  <MobileSajuSearch
    v-if="showMobileSearch"
    :paramData="paramData"
    @close="showMobileSearch = false"
    @selectItem="handleSearchSelectItem"
  />
</template>

<style lang="scss">
@import '@/assets/nangman_style/manse.scss';

.inner-base.st-wd-100per {
  width: 100% !important;

  @media (max-width: 1024px) {
    padding: 16px;
  }
}
.v-dialog-alert .alert-wrap .tit-box {
  white-space: pre-wrap;
}

.mobile-title-group-setting-btn,
.mobile-title-search-btn {
  display: none;
}

.saju-list-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  width: 100%;
}

@media (max-width: 768px) {
  .top_header_text_title .tit-box {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .mobile-title-group-setting-btn,
  .mobile-title-search-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .mobile-title-group-setting-btn {
    margin-left: auto;
  }

  .mobile-title-search-btn {
    color: #333;
  }

  .content-main > .mobile-header {
    z-index: 30 !important;
  }

  .result-box .list-box.mobile-list .popup-menu {
    z-index: 1 !important;
  }

  .tap-group-box.group_area.hOne {
    margin-top: 0;
  }

  .top_header_text_title {
    padding-top: 16px !important;
    padding-bottom: 12px !important;
    border-bottom: 1px solid var(--Gray-300, #ebebeb);
    margin-bottom: 0 !important;
    background: #fff;
  }

  .top_header_text_title .btn-group-setting {
    display: none;
  }

  .top_header_text_title .row-box {
    display: none;
  }

  .tap-group-box.group_area {
    margin-bottom: 8px;
    padding-bottom: 6px;
  }

  .result-box .data-box .hd-box {
    min-height: 38px !important;
    padding: 8px 12px !important;
    margin-top: 0 !important;
    background: #fff;
  }

  .result-box .list-box {
    margin-top: 0 !important;
  }

  .result-box .data-box .hd-box .btn-r .view-style-btn {
    width: 68px !important;
    height: 32px !important;
    padding: 4px !important;
    border-radius: 7px !important;
    overflow: hidden;
  }

  .result-box .data-box .hd-box .btn-r .view-style-btn .divider svg {
    height: 100% !important;
    width: 2px !important;
  }

  .result-box .data-box .hd-box .btn-r .view-style-btn .btn-grid,
  .result-box .data-box .hd-box .btn-r .view-style-btn .btn-list {
    width: 20px !important;
    height: 20px !important;
    background-size: 20px 20px !important;
  }

  .result-box .data-box .hd-box .btn-r .mobile-sort-trigger {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    border: none;
    background: transparent;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  .result-box .data-box .hd-box .btn-r .mobile-sort-trigger .mobile-sort-text {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.35px;
  }

  .mobile-sort-menu {
    min-width: 108px;
    border-radius: 8px !important;
    border: 1px solid var(--Gray-300, #ebebeb);
    background: #fff;
    padding: 4px !important;
  }

  .mobile-sort-menu .v-list-item {
    min-height: 34px !important;
    border-radius: 6px !important;
    padding-inline: 10px !important;
  }

  .mobile-sort-menu .v-list-item .v-list-item-title {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.35px;
    width: 100%;
    text-align: right;
  }

  .mobile-sort-menu .v-list-item .v-list-item__content {
    display: flex;
    justify-content: flex-end;
  }

  .mobile-sort-menu .v-list-item.is-active {
    background: var(--Orange-100, #fff8f5);
  }

  .mobile-sort-menu .v-list-item.is-active .v-list-item-title {
    color: var(--orange-300-main, #eb4c10);
    font-weight: 600;
  }
}

// 모바일 하단 분석권/포인트 바
.saju-service-mobile-credit-bar {
  display: none;
}

@media (max-width: 768px) {
  .saju-service-mobile-credit-bar {
    display: flex;
  }

  // MobileCreditBar 높이만큼 하단 여백 추가
  .content-main.mb-large {
    padding-bottom: 52px;
  }
}
</style>
